import axios from 'axios';

const plaidlink = document.createElement('script');

plaidlink.setAttribute('src', 'https://cdn.plaid.com/link/v2/stable/link-initialize.js');
document.head.append(plaidlink);

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let BASE_URL = window.location.origin;

const BASE_FOLDER = process.env.VUE_APP_BASE_FOLDER;

if (BASE_FOLDER) {
  BASE_URL = `${BASE_URL}/${BASE_FOLDER}`;
}

window.BASE_URL = BASE_URL;
